var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accreditations"},[_c('div',{staticClass:"inner"},[(_vm.settings && _vm.settings.accreditations_image)?_c('img',{attrs:{"src":_vm.settings.accreditations_image,"alt":"Our funeral director accreditations"}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }